import { permissaoUtils } from '@core/util/permissaoUtil';
import FuseSearch from '@fuse/core/FuseSearch';
import FuseShortcuts from '@fuse/core/FuseShortcuts';
import { Button, Icon, IconButton, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import EmpresaSelected from 'app/fuse-layouts/shared-components/EmpresaSelected';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  separator: {
    width: 1,
    height: 60,
    backgroundColor: theme.palette.divider,
  },
}));

function ToolbarLayoutFinanceiro(props) {
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const toolbarTheme = useSelector(({ fuse }) => fuse.settings.toolbarTheme);
  const user = useSelector(({ auth }) => auth.user);
  const classes = useStyles(props);
  const location = useLocation();
  const [visualizarDadosDashboard, setVisualizarDadosDashboard] = useContext(GlobalContext).visualizarDadosDashboard;

  const handleVisualizarDados = () => {
    setVisualizarDadosDashboard(!visualizarDadosDashboard);
  };

  return (
    !location?.pathname.includes('/public/') && (
      <ThemeProvider theme={toolbarTheme}>
        {!user.role || user.role.length === 0 ? (
          <div />
        ) : (
          <AppBar
            id="fuse-toolbar"
            className="flex relative z-10"
            color="default"
            style={{
              backgroundColor: toolbarTheme.palette.background.default,
              height: 56,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Toolbar className="container p-0 lg:px-24">
              {config.navbar.display && (
                <Hidden lgUp>
                  <NavbarMobileToggleButton className="w-64 h-56 p-0" />
                  <div className={classes.separator} />
                </Hidden>
              )}

              <div className="flex stepHome">
                <Link to="/">
                  <Tooltip title="Retornar para visão geral">
                    <IconButton className="w-70 h-70">
                      <Icon>home</Icon>
                    </IconButton>
                  </Tooltip>
                </Link>
              </div>
              <div className="flex flex-1">
                <Hidden mdDown>
                  <FuseShortcuts />
                </Hidden>
              </div>

              <div className="flex">
                <UserMenu />
                <div className={classes.separator} />
                <EmpresaSelected />
                <div className={classes.separator} />
                <FuseSearch />
                {location.pathname.includes('/visao-geral') && (
                  <>
                    <div className={classes.separator} />
                    <Tooltip
                      title={
                        visualizarDadosDashboard
                          ? 'Ocultar valores'
                          : !permissaoUtils.dashboard().visualizar
                          ? ''
                          : 'Exibir valores'
                      }
                    >
                      <Button onClick={() => permissaoUtils.dashboard().visualizar && handleVisualizarDados()}>
                        {visualizarDadosDashboard ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                      </Button>
                    </Tooltip>
                  </>
                )}
                <div className={classes.separator} />
                <Button className="stepAjuda">
                  <Icon>help</Icon>
                  <Typography className="mb-2 pl-2 normal-case">Ajuda</Typography>
                </Button>
              </div>
            </Toolbar>
          </AppBar>
        )}
      </ThemeProvider>
    )
  );
}

export default ToolbarLayoutFinanceiro;
